import React, { useState } from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';

const AddAttendance = ({ setAttendance }) => {
    const [student, setStudent] = useState('');
    const [status, setStatus] = useState('Present');

    const handleAddAttendance = (e) => {
        e.preventDefault();
        const newRecord = { id: Date.now(), student, status };
        setAttendance(prevAttendance => [...prevAttendance, newRecord]);
        setStudent('');
    };

    return (
        <form onSubmit={handleAddAttendance} className="mb-6">
            <h4 className="text-lg font-semibold mb-2">Add Attendance Record</h4>
            <div className="flex flex-col space-y-2">
                <Input type="text" placeholder="Student Name" value={student} onChange={(e) => setStudent(e.target.value)} />
                <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600">
                    <option value="Present">Present</option>
                    <option value="Absent">Absent</option>
                </select>
                <Button type="submit">Add Record</Button>
            </div>
        </form>
    );
};

export default AddAttendance;
